import React from 'react'
import piston8D from '../assets/images/piston8D.jpg'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'
import GlobalFooter from '../components/GlobalFooter'
import TeaserSection2 from '../components/TeaserSection2'

export default function About() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.6 })

  return (
    <section className="relative h-[120vh] w-full overflow-visible">
      {/* Hero */}
      <div className="sticky top-0 h-screen w-full overflow-hidden">
        <img
          src={piston8D}
          alt="About Strobe"
          className="absolute top-0 left-0 w-full h-screen object-cover will-change-transform"
        />
        <div className="absolute bottom-12 left-6 md:left-8 z-20 pointer-events-none">
          <h1 className="font-headline text-[15vw] md:text-[6vw] leading-none drop-shadow-md text-white">
            About Strobe
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <main className="relative z-10 bg-black">
        {/* Headline Section */}
        <section className="py-16">
  <div className="max-w-screen-xl mx-auto px-6 md:px-8">
    <h2 className="text-[clamp(2.5rem,6vw,65px)] leading-[100%] font-medium text-strobe-offwhite">
      Strobe Aviation for the last 10 years.
    </h2>
  </div>

  <div className="max-w-screen-xl mx-auto px-6 md:px-8">
    <div className="w-full md:w-[70%] md:ml-[30%] mt-10 space-y-6">
      <p className="text-lg md:text-2xl leading-snug text-strobe-offwhite">
        <strong>Making aircraft—and passengers—seen. At Strobe, visibility is everything.</strong>
      </p>

      <p className="text-lg md:text-2xl leading-snug text-strobe-offwhite">
        In aviation, the strobe light is what signals you're about to move—it tells the world you're here.
        In photography, the Strobe is what transforms the unseen into something vivid and striking.
      </p>

      <p className="text-lg md:text-2xl leading-snug text-strobe-offwhite">
        That's precisely what we do.
      </p>

      <p className="text-base md:text-lg leading-relaxed text-strobe-offwhite">
        Strobe exists to make aircraft visible to the world—whether that's for a listing, a fleet showcase, or a story that deserves to be told.
        We're built at the intersection of aviation and cinematography. Our clients range from brokers and flight schools to charter operators and private
        owners—anyone who needs elite media, fast turnarounds, and expertise in aircraft.
      </p>

      <p className="text-base md:text-lg leading-relaxed text-strobe-offwhite">
        When we're not behind the lens, we're behind the yoke. On the pilot services side, Strobe doesn't just send a pilot—we deliver a seamless journey.
        We learn about your mission and preferences, and ensure your entire flight experience feels curated, not just covered. We're fast, flexible, and precise. And we're built for aviation from the inside out.
      </p>
    </div>
  </div>
</section>


        {/* Counter Section */}
<section className="py-20 px-6 md:px-8 bg-black" ref={ref}>
  <div className="max-w-screen-xl mx-auto">
    <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-16">

      {/* Counter Item */}
      <div className="relative pl-4 border-l border-strobe-red">
        <p className="text-base md:text-lg text-strobe-red mb-2">Hours in Flight</p>
        <div className="text-[52px] md:text-[60px] leading-none font-semibold text-strobe-red">
          {inView && <CountUp end={13326} separator="," duration={2.5} />}
        </div>
      </div>

      <div className="relative pl-4 border-l border-strobe-red">
        <p className="text-base md:text-lg text-strobe-red mb-2">Photoshoots delivered</p>
        <div className="text-[52px] md:text-[60px] leading-none font-semibold text-strobe-red">
          {inView && <CountUp end={4400} separator="," duration={2.5} />}
        </div>
      </div>

      <div className="relative pl-4 border-l border-strobe-red">
        <p className="text-base md:text-lg text-strobe-red mb-2">Cities Taken</p>
        <div className="text-[52px] md:text-[60px] leading-none font-semibold text-strobe-red">
          {inView && <CountUp end={1939} duration={2.5} />}
        </div>
      </div>

      <div className="relative pl-4 border-l border-strobe-red">
        <p className="text-base md:text-lg text-[#EB040D] mb-2">Customer Satisfaction</p>
        <div className="text-[52px] md:text-[60px] leading-none font-semibold text-[#EB040D]">
          {inView && (
            <>
              <CountUp end={100} duration={2.5} />
              <span className="text-[32px] md:text-[40px] align-super">%</span>
            </>
          )}
        </div>
      </div>

    </div>
  </div>
</section>

        <TeaserSection2/>
        <GlobalFooter/>
      </main>
    </section>
  )
}
